// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__ugtCe","item__left":"styles_item__left__z6_s4"};